export const CART_CONSTS = {
    GET_CART_PRODUCTS: "GET_CART_PRODUCTS",
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    CHANGE_PRODUCT_COUNT_IN_CART: "CHANGE_PRODUCT_COUNT_IN_CART",
    CLEAR_USER_CART: "CLEAR_USER_CART",
    ADD_ADDRESS: "ADD_ADDRESS",
};
